var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    [
      _c("modal-pop", {
        attrs: {
          opened: _vm.isPopupOpen,
          modalHeader: true,
          modalFooter: true,
          btnClose: true,
          titleCenter: true,
          title: "MPSH-01-01-00-09"
        },
        on: {
          "update:opened": function($event) {
            _vm.isPopupOpen = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function() {
              return [
                _c(
                  "strong",
                  { staticClass: "info-question mtop-12 btm-border" },
                  [_vm._v(" " + _vm._s(_vm.$t("MPSH-01-01-01-01")) + " ")]
                ),
                _c("div", { staticClass: "desc mtop-12 mbtm-12" }, [
                  _vm._v(" " + _vm._s(_vm.$t("MPSH-01-01-01-02")) + " ")
                ]),
                _c("div", { staticClass: "notice -ulist-type" }, [
                  _c("div", { staticClass: "notice-tit" }, [
                    _c("p", [
                      _vm._v(" " + _vm._s(_vm.$t("MPSH-01-01-00-01")) + " ")
                    ])
                  ]),
                  _c("div", { staticClass: "notice-cont" }, [
                    _c("ul", { staticClass: "ulist bar" }, [
                      _c("li", [
                        _vm._v(" " + _vm._s(_vm.$t("MPSH-01-01-01-03")) + " ")
                      ]),
                      _c("li", [
                        _vm._v(" " + _vm._s(_vm.$t("MPSH-01-01-01-04")) + " ")
                      ])
                    ])
                  ])
                ])
              ]
            },
            proxy: true
          },
          {
            key: "footer",
            fn: function() {
              return [
                _c(
                  "button",
                  {
                    staticClass: "btn bottom negative",
                    on: {
                      click: function($event) {
                        return _vm.decline()
                      }
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("MPSH-01-01-00-05")) + " ")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "btn bottom positive",
                    on: {
                      click: function() {
                        ;(_vm.isPopupOpen = false),
                          _vm.$router.push({ name: "pushNotiStup" })
                      }
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("MPSH-01-01-00-04")) + " ")]
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("push-stup-no-popup", {
        ref: "pushStupNoPopup",
        attrs: { opened: _vm.isNoPopupOpen },
        on: {
          "update:opened": function($event) {
            _vm.isNoPopupOpen = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }